//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "loading",
  data(){
    return{
      loadTitle:'正在加载中......'
    }
  },
  mounted() {
    this.$store.commit('UPDATE_HEAD',false);
    this.$store.commit('UPDATE_FOOTER',false);
  },
}



// WEBPACK FOOTER //
// ./src/components/loading.vue